// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Bangkok date formatting only
// 2. Separation of Concerns - Pure display utility
// 3. Modular Architecture - Reusable across voice UI tables
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

// Refer to: docs/manual/02-voice-process.md

const BANGKOK_TZ = 'Asia/Bangkok';

/**
 * Format an ISO timestamp as DD/MM/YYYY in Asia/Bangkok.
 * @param {string|null|undefined} isoString
 * @returns {string}
 */
export function formatBangkokDate(isoString) {
  if (!isoString) return 'Unknown';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return 'Unknown';
  return date.toLocaleDateString('en-GB', { timeZone: BANGKOK_TZ });
}

/**
 * Prefer completed_at for finished tasks; fall back to created_at.
 * @param {{ status?: string, completed_at?: string|null, created_at?: string|null }} file
 * @returns {string}
 */
export function formatVoiceTaskDisplayDate(file) {
  const iso =
    file?.status === 'completed' && file?.completed_at
      ? file.completed_at
      : file?.created_at;
  return formatBangkokDate(iso);
}
